import { z } from 'zod'
import { ApiLocale } from '@library/enums'

/** 取得場站清單 - 場站資料 Schema */
export const stationDataSchema = z.object({
  code: z.string(),
  name: z.string(),
  enable: z.boolean()
})

/** 取得場站清單 - 資料 Schema */
export const stationListDataSchema = z.object({
  lang: z.enum(ApiLocale),
  station: z.array(stationDataSchema)
})

/** 取得場站清單 - 場站資料 */
export interface StationData extends z.infer<typeof stationDataSchema> {}

/** 取得場站清單 - 資料 */
export interface StationListData
  extends z.infer<typeof stationListDataSchema> {}
